/**
 * An 8px status dot with a screen-reader label. One of three files allowed
 * `rounded-full`. Tones follow the Neutral Bad State Rule: neutral (mid gray),
 * active (the strong neutral, never Soft Green: D18), crit (Coral).
 */
import clsx from 'clsx'
import type { StatusTone } from './types'

export interface StatusDotProps {
  tone: StatusTone
  /** What the dot means ("Scan running", "Assessment is stale"); read by screen readers only. */
  label: string
  className?: string
}

const TONE: Record<StatusTone, string> = {
  neutral: 'bg-sev-low',
  active: 'bg-inverse',
  crit: 'bg-sev-crit',
}

export function StatusDot({ tone, label, className }: StatusDotProps) {
  return (
    <span className={clsx('inline-flex flex-none items-center', className)}>
      <span aria-hidden="true" className={clsx('inline-block h-2 w-2 rounded-full', TONE[tone])} />
      <span className="sr-only">{label}</span>
    </span>
  )
}

export default StatusDot
